<template>
  <div>
    <div v-for="group in groups" :key="group.title">
      <div v-if="!group.isExpanded" class="item" @click="group.isExpanded = !group.isExpanded"><i class="el-icon-caret-right" /><span style="margin-left: 5px">{{ group.title }}</span></div>
      <div v-if="group.isExpanded" class="item" @click="group.isExpanded = !group.isExpanded"><i class="el-icon-caret-bottom" /><span style="margin-left: 5px">{{ group.title }}</span></div>
      <ul v-if="group.isExpanded">
        <li v-for="item in group.items" :key="item.id">
          <div class="item" style="display: flex;justify-content: space-between;" @click="handleClick(item)">
            <div style="display: inline-block">
              <div v-if="currentRowId === item.id" style="width: 14px;height: 14px;background-color: #6ABCE1;border-radius: 50%;display: inline-block" />
              <div v-else style="width: 14px;height: 14px;background-color: #DEE6EE;border-radius: 50%;display: inline-block" />
              <p style="margin-left: 30px;display: inline-block" v-html="item.content" />
            </div>
            <span v-if="item.content1 !== null" style="margin-right: 60px;align-self: center;display: flex">
              <span style="align-self: center;">{{ item.content1 }}</span>
              <i v-if="currentRowId === item.id && showRight" class="el-icon-arrow-left" style="align-self: center;margin-left: 10px;font-size: 18px" />
              <i v-else class="el-icon-arrow-right" style="align-self: center;margin-left: 10px;font-size: 18px" />
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groups: { type: Array, default: () => [] },
    currentRowId: { type: Number, default: 0 },
    showRight: { type: Boolean, default: false }
  },
  methods: {
    handleClick(item) {
      this.$emit('change', item)
    }
  }
}
</script>

<style scoped>
h2 {
  font-weight: bold;
  cursor: pointer;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.item {
  padding: 10px;
  border-bottom: 1px solid #DDE0E7;
}
</style>
